/**
 * Created by calhosh on 10/14/2024
 */

import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export function setFormV2ToasterVisibilityReducer(state = initialState.toasterDetails, action) {
	switch (action.type) {
		case types.SET_TOASTER_VISIBILITY: {
			const {showToaster} = action.payload;

			if (showToaster === false) {
				return {...state, showToaster: false};
			} else {
				return {...state, ...action.payload, showToaster: true};
			}
		}
		default:
			return state;
	}
}
